import useJwt from "@/auth/jwt/useJwt";
const axios = useJwt.axiosIns;

export async function getSettlements() {
  const res = await axios.get(`${process.env.VUE_APP_API_URL}/settlement`);
  return res.data;
}

export async function getSettlement(settlementId) {
  const res = await axios.get(`${process.env.VUE_APP_API_URL}/settlement/${settlementId}`);
  return res.data;
}

export async function updateSettlement(data) {
  const formData = new FormData();
  formData.append("id", data.id);
  formData.append("file", data.attachment);
  formData.append("status", data.status);

  await axios.put(`${process.env.VUE_APP_API_URL}/settlement`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

export async function addSettlement(settlement) {
  const res = await axios.post(`${process.env.VUE_APP_API_URL}/settlement`, { settlement });
  return res.data;
}
